import { POSTAPI, API_URL } from "./config";

export const API_LOGIN = async (data) => {
  const formData = new FormData();
  formData.append("email", data.email);
  formData.append("password", data.password);
  const res = await POSTAPI(API_URL.sign_in, formData);
  return res;
};
